export const CouponValidation = (data) => {
    return new Promise((resolve) => {
        const errors = {};

        // Coupon Code validation
        if (!data.code || data.code.trim() === '') {
            errors.code = 'Coupon code is required';
        } else if (data.code.trim().length < 3) {
            errors.code = 'Coupon code must be at least 3 characters';
        } else if (data.code.trim().length > 50) {
            errors.code = 'Coupon code must not exceed 50 characters';
        } else if (!/^[A-Z0-9_-]+$/.test(data.code.trim().toUpperCase())) {
            errors.code = 'Coupon code can only contain letters, numbers, hyphens, and underscores';
        }

        // Coupon Name validation
        if (!data.name || data.name.trim() === '') {
            errors.name = 'Coupon name is required';
        } else if (data.name.trim().length < 3) {
            errors.name = 'Coupon name must be at least 3 characters';
        }

        // Description validation (optional based on schema)
        if (data.description && data.description.trim() !== '' && data.description.trim().length < 10) {
            errors.description = 'Description must be at least 10 characters if provided';
        }

        // Discount Type validation
        if (!data.discountType) {
            errors.discountType = 'Discount type is required';
        } else if (!['percentage', 'fixed'].includes(data.discountType)) {
            errors.discountType = 'Invalid discount type';
        }

        // Discount Value validation
        if (data.discountValue === undefined || data.discountValue === null || data.discountValue === '') {
            errors.discountValue = 'Discount value is required';
        } else {
            const value = parseFloat(data.discountValue);
            if (isNaN(value) || value <= 0) {
                errors.discountValue = 'Discount value must be greater than 0';
            } else if (data.discountType === 'percentage' && value > 100) {
                errors.discountValue = 'Percentage discount cannot exceed 100%';
            }
        }

        // Max Discount Amount validation (optional, only for percentage type)
        if (data.maxDiscountAmount !== undefined && data.maxDiscountAmount !== null && data.maxDiscountAmount !== '') {
            const maxDiscount = parseFloat(data.maxDiscountAmount);
            if (isNaN(maxDiscount) || maxDiscount < 0) {
                errors.maxDiscountAmount = 'Maximum discount amount must be 0 or greater';
            }
            // Only applicable for percentage discounts
            if (data.discountType === 'fixed' && maxDiscount) {
                errors.maxDiscountAmount = 'Maximum discount amount is only applicable for percentage discounts';
            }
        }

        // Applicable On validation
        if (!data.applicableOn) {
            errors.applicableOn = 'Applicability is required';
        } else if (!['service', 'product', 'both'].includes(data.applicableOn)) {
            errors.applicableOn = 'Invalid applicability option';
        }

        // Min Purchase Amount validation (optional)
        if (data.minPurchaseAmount !== undefined && data.minPurchaseAmount !== null && data.minPurchaseAmount !== '') {
            const minAmount = parseFloat(data.minPurchaseAmount);
            if (isNaN(minAmount) || minAmount < 0) {
                errors.minPurchaseAmount = 'Minimum purchase amount must be 0 or greater';
            }
        }

        // Max Usage Limit validation (optional based on schema)
        if (data.maxUsageLimit !== undefined && data.maxUsageLimit !== null && data.maxUsageLimit !== '') {
            const limit = parseInt(data.maxUsageLimit);
            if (isNaN(limit) || limit < 1) {
                errors.maxUsageLimit = 'Usage limit must be at least 1';
            }
        }

        // Per User Limit validation (optional)
        if (data.perUserLimit !== undefined && data.perUserLimit !== null && data.perUserLimit !== '') {
            const perUserLimit = parseInt(data.perUserLimit);
            if (isNaN(perUserLimit) || perUserLimit < 1) {
                errors.perUserLimit = 'Per user limit must be at least 1';
            }
            // Validate that per user limit doesn't exceed max usage limit
            if (data.maxUsageLimit && perUserLimit > parseInt(data.maxUsageLimit)) {
                errors.perUserLimit = 'Per user limit cannot exceed total usage limit';
            }
        }

        // Used Count validation (for edit mode)
        if (data.usedCount !== undefined && data.usedCount !== null) {
            const usedCount = parseInt(data.usedCount);
            if (isNaN(usedCount) || usedCount < 0) {
                errors.usedCount = 'Used count must be 0 or greater';
            }
            // Check if used count exceeds max usage limit
            if (data.maxUsageLimit && usedCount > parseInt(data.maxUsageLimit)) {
                errors.maxUsageLimit = 'Maximum usage limit cannot be less than already used count';
            }
        }

        // Start Timestamp validation
        if (!data.startTimestamp) {
            errors.startTimestamp = 'Start date is required';
        } else {
            const startTime = typeof data.startTimestamp === 'number' 
                ? data.startTimestamp 
                : new Date(data.startTimestamp).getTime();
            
            if (isNaN(startTime)) {
                errors.startTimestamp = 'Invalid start date format';
            }
        }

        // End Timestamp validation
        if (!data.endTimestamp) {
            errors.endTimestamp = 'End date is required';
        } else {
            const endTime = typeof data.endTimestamp === 'number' 
                ? data.endTimestamp 
                : new Date(data.endTimestamp).getTime();
            
            if (isNaN(endTime)) {
                errors.endTimestamp = 'Invalid end date format';
            } else if (data.startTimestamp) {
                const startTime = typeof data.startTimestamp === 'number' 
                    ? data.startTimestamp 
                    : new Date(data.startTimestamp).getTime();
                
                if (endTime <= startTime) {
                    errors.endTimestamp = 'End date must be after start date';
                }
            }
        }

        // Unit IDs validation
        if (!data.unitIds || (Array.isArray(data.unitIds) && data.unitIds.length === 0)) {
            errors.unitIds = 'At least one unit must be selected';
        }

        // Created By validation
        if (!data.createdBy) {
            errors.createdBy = 'Creator information is required';
        }

        resolve(errors);
    });
};